import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { InputField, InputLabel } from '@presentation/components';
import * as Styled from '../styled';

export const Step8: FC = () => {
  const { translate } = useTranslation();
  return (
    <>
      <Styled.BlueInfoBox full>{translate('common.inputs.step7warningText')}</Styled.BlueInfoBox>
      <Styled.OnboardingInputWrapperContainer>
        <Styled.OnboardingInputWrapper>
          <InputLabel requiredColor="red" required>
            {translate('common.inputs.veterinaryInfo.label').replaceAll('<br/>', '')}
          </InputLabel>
          <InputField name="veterinaryInfo" required />
        </Styled.OnboardingInputWrapper>
      </Styled.OnboardingInputWrapperContainer>
    </>
  );
};
